import React, { useEffect, useState } from 'react';
import { REPORT_FILTER_PERIODS } from '../../../../../constants/defaultValues';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeIncreaseReportsDates,
    changeIncreaseReportsPage,
    clearIncreaseReports,
    getIncreaseReports,
} from '../../../../../store/actions/increase-reports';
import RangePicker from '../../../../shared/Point/Filters/RangePicker/RangePicker';

const rangePeriod = REPORT_FILTER_PERIODS.find(period => period.key === 'range');
const initialPeriod = REPORT_FILTER_PERIODS[0];

const Period = ({ generateParams }) => {
    const dispatch = useDispatch();

    const [selectedPeriod, setSelectedPeriod] = useState(initialPeriod);
    const dates = useSelector(state => state.increaseReports.dates);
    const { createStartDate, createEndDate } = dates;

    const clearDates = () => {
        dispatch(changeIncreaseReportsDates({ createStartDate: null, createEndDate: null }));
    };

    const clearReportData = () => {
        dispatch(clearIncreaseReports());
    };

    const clearAll = () => {
        clearDates();
        clearReportData();
    };

    const getReportData = (createStartDate, createEndDate) => {
        if (!createStartDate || !createEndDate) return;

        dispatch(changeIncreaseReportsPage(1));
        dispatch(
            getIncreaseReports(
                generateParams({ createStartDate, createEndDate, currentPageParam: 1 }),
            ),
        );
    };

    const onPeriodChange = period => {
        clearAll();
        setSelectedPeriod(period);

        if (period.key !== rangePeriod.key) {
            const { startTime, endTime } = period.getRange();
            dispatch(
                changeIncreaseReportsDates({ createStartDate: startTime, createEndDate: endTime }),
            );
            getReportData(startTime, endTime);
        }
    };

    const handleDateChange = (date, callback) => {
        if (date) {
            clearReportData();
            setSelectedPeriod(rangePeriod);
            callback();
        }
    };

    const onStartDateChange = date => {
        handleDateChange(date, () => {
            dispatch(changeIncreaseReportsDates({ createStartDate: date.getTime() }));
        });
    };

    const onEndDateChange = date => {
        handleDateChange(date, () => {
            dispatch(changeIncreaseReportsDates({ createEndDate: date.getTime() }));
        });
    };

    useEffect(() => {
        const { startTime, endTime } = selectedPeriod.getRange();
        dispatch(
            changeIncreaseReportsDates({ createStartDate: startTime, createEndDate: endTime }),
        );

        getReportData(startTime, endTime);
    }, []);

    return (
        <RangePicker
            periods={REPORT_FILTER_PERIODS}
            selectedPeriod={selectedPeriod}
            onPeriodChange={onPeriodChange}
            startDate={createStartDate}
            endDate={createEndDate}
            onStartDateChange={onStartDateChange}
            onEndDateChange={onEndDateChange}
            onSearch={getReportData}
            showTime
        />
    );
};

export default Period;
